import { Box } from "@mui/material";
import { Banner } from "components/ui/customComponents/banner";
import { CircularSVG } from "components/ui/customComponents/circularSVG";
import { ImageUser } from "./imageUser";
import { InfoUser } from "./infoUser";

export const BannerInfoUser = () => {
  return (
    <Banner
      background="linear-gradient(220deg, rgb(9, 12, 17) 10%, #0c2239 35%, #2b1e38 55%, rgb(9, 12, 17) 90%)"
      height="270px"
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          color: "white",
          position: "relative",
          paddingY: "25px",
        }}
      >
        <CircularSVG />
        <ImageUser />
        <InfoUser />
      </Box>
    </Banner>
  );
};
